// src/index.tsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter, Routes, Route } from 'react-router-dom';
import App from './App';
import Review from './Review';
import { Launcher } from './Launcher';
import { MalaysiaApp } from './MalaysiaApp';
import { VietnamApp } from './VietnamApp';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <HashRouter>
      <Routes>
        <Route path="/" element={<Launcher />} />
        <Route path="/india" element={<App />} />
        <Route path="/malaysia" element={<MalaysiaApp />} />
        <Route path="/vietnam" element={<VietnamApp />} />
        <Route path="/review" element={<Review />} />
      </Routes>
    </HashRouter>
  </React.StrictMode>
);